.code {
  border-radius: 2px;
}

.codeMatch {
  background-color: #fff3a3;
  font-weight: 600;
}

.nameMatch {
  background-color: #fff3a3;
  color: var(--text-color, #1f2937);
  font-weight: 600;
}
